import { ResolveFn } from '@angular/router';
import { BrowserService } from 'src/_lib/service/browser.service';
import { inject } from '@angular/core';



export const newsComponentResolver: ResolveFn<number | null> = (route, state) => {
  const browser = inject(BrowserService);
 
  const blogid = route.params['blogid'];
  if (route.url[0].path == 'news' && route.url[1].path == 'news'){
    browser.localStorage?.setItem('activeNewsComponent',String('news'));
    return +blogid;
  }
  else if(route.url[0].path == 'news' && route.url[1].path == 'press-releases'){
    browser.localStorage?.setItem('activeNewsComponent',String('press-releases'));
    return +blogid;
  }
  else if(route.url[0].path == 'news' && route.url[1].path == 'tech-articles'){
    browser.localStorage?.setItem('activeNewsComponent',String('tech-articles'));
    return +blogid;
  }
  else if(route.url[0].path == 'news' && route.url[1].path == 'sponsored-teams'){
    browser.localStorage?.setItem('activeNewsComponent',String('sponsored-teams'));
    return +blogid;
  }
  else{
    browser.localStorage?.setItem('activeNewsComponent',String('news'))
    return +blogid;
  }
};

export const blogComponentResolver: ResolveFn<string> = (route, state) =>{
  if (route.url[0].path == 'blog') {
    const browser = inject(BrowserService);
    browser.localStorage?.setItem('activeNewsComponent',String('blog'))
    return 'blog'
  }
  return 'noblog';
}


